import { render, staticRenderFns } from "./SlideBlockWrapper.vue?vue&type=template&id=1f4e1e0c&scoped=true&"
import script from "./SlideBlockWrapper.vue?vue&type=script&lang=js&"
export * from "./SlideBlockWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SlideBlockWrapper.vue?vue&type=style&index=0&id=1f4e1e0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e1e0c",
  null
  
)

export default component.exports